import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

// Global axios configuration  
axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const documentTemplateService = {
  getOwnDocumentTemplates,
};

/**
 * Get document templates for the current company
 * @returns {Promise} Response with document templates
 */
function getOwnDocumentTemplates() {
  return axios
    .get("companies/own/documenttemplates", { headers: authHeader() })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

